var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{attrs:{"variant":"danger","show":true}},[_vm._v("You do not have access to this application")])}
var staticRenderFns = []

export { render, staticRenderFns }